import styled from "styled-components"

export const HorizontalGroupCss = styled.div<{ spacing?: number }>`
	flex-direction: row;
	> * {
		margin-right: ${(props) => (props.spacing ? props.spacing + "px" : "none")};
	}

	& :last-child {
		margin-right: ${(props) => (props.spacing ? 0 : "none")};
	}
`

export const VerticalGroupCss = styled.div<{ spacing?: number }>`
	flex-direction: column;
	> * {
		margin-bottom: ${(props) => (props.spacing ? props.spacing + "px" : "none")};
	}
	& :last-child {
		margin-bottom: ${(props) => (props.spacing ? 0 : "none")};
	}
`

export const DirectionSwitchGroupCss = styled.div<{ spacing?: number }>`
	flex-direction: row;
	> * {
		margin-right: ${(props) => (props.spacing ? props.spacing + "px" : "none")};
	}

	& :last-child {
		margin-right: ${(props) => (props.spacing ? 0 : "none")};
	}

	@media (max-width: 800px) {
		flex-direction: column;
		> * {
			margin-bottom: ${(props) => (props.spacing ? props.spacing + "px" : "none")};
		}
		& :last-child {
			margin-bottom: ${(props) => (props.spacing ? 0 : "none")};
		}
	}
`
